<template>
  <div class="black-list">
    <div class="black-list__sidebar">
      <Sidebar />
    </div>
    <div class="black-list__content">
      <h1 class="black-list__content__tittle">Black List</h1>
      <hr class="black-list__content__separator" />
      <div
        class="d-flex justify-content-center align-items-center spinner-container"
        v-if="isLoading"
      >
        <img src="@/assets/gif/spinner.gif" width="200" height="200" />
      </div>
      <Table
        ref="blackListTable"
        v-if="!isLoading"
        :type="type"
        class="mt-5"
        @openModal="openAddModal"
      />
    </div>

    <b-modal
      id="blacklist-add-modal"
      :title="isEditing ? 'Edit Black List' : 'Add Black List'"
      hide-footer
      scrollable
    >
      <b-form class="blacklist-modal__form">
        <div class="blacklist-modal__row">
          <label class="blacklist-modal__row--label" for="bl-type">
            Type <b style="color: red">*</b>
          </label>
          <div class="p-inputgroup blacklist-modal__row--input">
            <span class="p-inputgroup-addon">
              <i class="pi pi-list"></i>
            </span>
            <Dropdown
              id="bl-type"
              v-model="newItem.type"
              :options="typeOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Select a type"
            />
          </div>
        </div>
        <div class="blacklist-modal__row">
          <label class="blacklist-modal__row--label" for="bl-value">
            Value <b style="color: red">*</b>
          </label>
          <div class="p-inputgroup blacklist-modal__row--input">
            <span class="p-inputgroup-addon">
              <i :class="newItem.type === 'email' ? 'pi pi-envelope' : 'pi pi-globe'"></i>
            </span>
            <InputText
              id="bl-value"
              v-model="newItem.value"
              :placeholder="newItem.type === 'email' ? 'Enter email address' : 'Enter domain'"
            />
          </div>
        </div>
        <div class="blacklist-modal__row">
          <label class="blacklist-modal__row--label" for="bl-category">
            Category <b style="color: red">*</b>
          </label>
          <div class="p-inputgroup blacklist-modal__row--input">
            <span class="p-inputgroup-addon">
              <i class="pi pi-tag"></i>
            </span>
            <Dropdown
              id="bl-category"
              v-model="newItem.category"
              :options="categoryOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Select a category"
            />
          </div>
        </div>
        <div class="blacklist-modal__row">
          <label class="blacklist-modal__row--label" for="bl-queue-send">
            Inbox<b style="color: red">*</b>
          </label>
          <div class="p-inputgroup blacklist-modal__row--input">
            <span class="p-inputgroup-addon">
              <i class="pi pi-send"></i>
            </span>
            <Dropdown
              id="bl-queue-send"
              v-model="newItem.queue_send"
              :options="queueSendOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Select queue send"
            />
          </div>
        </div>
        <div class="blacklist-modal__row blacklist-modal__row--switch">
          <label class="blacklist-modal__row--label">Status</label>
          <b-form-checkbox v-model="newItem.status" switch>
            {{ newItem.status ? 'Active' : 'Inactive' }}
          </b-form-checkbox>
        </div>
        <div class="blacklist-modal__row">
          <label class="blacklist-modal__row--label" for="bl-created-at">Created At</label>
          <div class="p-inputgroup blacklist-modal__row--input">
            <span class="p-inputgroup-addon">
              <i class="pi pi-calendar"></i>
            </span>
            <InputText id="bl-created-at" v-model="newItem.created_at" disabled />
          </div>
        </div>
        <div class="blacklist-modal__row">
          <label class="blacklist-modal__row--label" for="bl-last-modified">Last Modified</label>
          <div class="p-inputgroup blacklist-modal__row--input">
            <span class="p-inputgroup-addon">
              <i class="pi pi-calendar-plus"></i>
            </span>
            <InputText id="bl-last-modified" v-model="newItem.last_modified" disabled />
          </div>
        </div>

        <b-overlay class="overlay-button" :show="isSaving" rounded opacity="0.6" spinner-small>
          <b-button class="blacklist-modal__button" size="sm" @click="addItem">
            {{ isEditing ? 'Update' : 'Save' }}
          </b-button>
        </b-overlay>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import Sidebar from "@/components/layout/Sidebar.vue";
import Table from "@/components/Table.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "BlackList",
  components: {
    Sidebar,
    Table,
  },
  data() {
    return {
      currentCompanyDepartment: null,
      isLoading: false,
      isSaving: false,
      isEditing: false,
      editItemId: null,
      type: "BlackList",
      newItem: {
        type: null,
        value: "",
        status: true,
        category: null,
        queue_send: null,
        created_at: "",
        last_modified: "",
      },
      typeOptions: [
        { label: "Email", value: "email" },
        { label: "Domain", value: "domain" },
      ],
      queueSendOptions: [
        { label: "Queue", value: "queue" },
        { label: "Non LTL", value: "non_ltl" },
      ],
      categoryOptions: [
        { label: "GLT", value: "glt" },
        { label: "ACCU", value: "accu" },
        { label: "TAI/EFreight", value: "tai/efreight" },
        { label: "Agents", value: "agents" },
        { label: "Special Customers", value: "special customers" },
        { label: "Blacklist LTL", value: "blacklist ltl" },
        { label: "Manual Handling", value: "manual handling" },
        { label: "Carriers", value: "carriers" },
        { label: "Identified Shippers", value: "identified shippers" },
      ],
    };
  },
  computed: {
    ...mapGetters("user", ["showCurrentCompanyDepartment"]),
  },
  watch: {
    async showCurrentCompanyDepartment() {
      if (this.currentCompanyDepartment) {
        this.currentCompanyDepartment = this.showCurrentCompanyDepartment;
      }
    },
  },
  async created() {
    this.currentCompanyDepartment = JSON.parse(localStorage.getItem("company-data"));
    this.currentUserInfo = JSON.parse(localStorage.getItem("user-info"));
  },
  methods: {
    ...mapActions("blackList", ["createBlackListItem", "updateBlackListItem"]),
    openAddModal(rowData) {
      if (rowData && rowData.id) {
        this.isEditing = true;
        this.editItemId = rowData.id;
        this.newItem = {
          type: rowData.type,
          value: rowData.value,
          status: rowData.status === "active",
          category: rowData.category,
          queue_send: rowData.queue_send || null,
          created_at: rowData.created_at ? this.formatDateTime(rowData.created_at) : "",
          last_modified: rowData.last_modified ? this.formatDateTime(rowData.last_modified) : "",
        };
      } else {
        this.isEditing = false;
        this.editItemId = null;
        const now = this.formatDateTime(new Date().toISOString());
        this.newItem = {
          type: null,
          value: "",
          status: true,
          category: null,
          queue_send: null,
          created_at: now,
          last_modified: now,
        };
      }
      this.$bvModal.show("blacklist-add-modal");
    },
    closeAddModal() {
      this.$bvModal.hide("blacklist-add-modal");
      this.isEditing = false;
      this.editItemId = null;
      this.newItem = {
        type: null,
        value: "",
        status: true,
        category: null,
        queue_send: null,
        created_at: "",
        last_modified: "",
      };
    },
    formatDateTime(isoString) {
      if (!isoString) return "";
      const d = new Date(isoString);
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    async addItem() {
      if (!this.newItem.type || !this.newItem.value.trim()) return;
      this.isSaving = true;
      let response;
      if (this.isEditing) {
        response = await this.updateBlackListItem({
          id: this.editItemId,
          body: {
            type: this.newItem.type,
            value: this.newItem.value.trim(),
            status: this.newItem.status ? "active" : "inactive",
            category: this.newItem.category,
            queue_send: this.newItem.queue_send,
          },
        });
      } else {
        response = await this.createBlackListItem({
          type: this.newItem.type,
          value: this.newItem.value.trim(),
          status: this.newItem.status ? "active" : "inactive",
          category: this.newItem.category,
          queue_send: this.newItem.queue_send,
          created_by: this.currentUserInfo?.username,
        });
      }
      this.isSaving = false;
      if (response?.status >= 200 && response?.status < 300) {
        this.closeAddModal();
        const currentSearch = this.$refs.blackListTable.searchField;
        const searchPayload = currentSearch ? { value: currentSearch } : undefined;
        await this.$refs.blackListTable.getAllBlackList(searchPayload);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.black-list {
  display: flex;
  &__sidebar {
    width: 9%;
  }
  &__content {
    width: 91%;
    margin-top: 2rem;
    &__tittle {
      font-weight: bold;
    }
    &__separator {
      width: 95%;
      margin: auto;
    }
  }
}

.blacklist-modal {
  &__form {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    padding: 0rem 1rem 2rem 1rem;
  }
  &__row {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    &--label {
      font-weight: 600;
      font-size: 0.9rem;
      margin-bottom: 0;
    }
    &--input {
      width: 100%;
    }
    &--switch {
      flex-direction: row;
      align-items: center;
      gap: 1rem;
      margin-top: 0.5rem;
    }
  }
  &__button {
    color: #000000 !important;
    background-color: #00FF00 !important;
    border: none;
    border-radius: 8px;
    display: flex;
  }
}

.overlay-button {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

@media (max-width: 900px) {
  .black-list {
    &__sidebar {
      width: 0%;
    }
    &__content {
      width: 98%;
      margin-top: 7rem;
    }
  }
}
</style>
